import React from "react"
import { Container, } from "reactstrap"
//components

import Breadcrumbs from "../../components/Common/Breadcrumb"
import ServicesDeletionLogs from "./ServicesDeletionLogs"

const newPage = () => {
  // meta title
  document.title = "سجلات| DBsaloni Admin & Dashboard "

  return (
    <>
      <div className="page-content">
        <Container fluid={false}>
          <Breadcrumbs
            title="سجلات "
            breadcrumbItem="سجلات الحذف "
          />
      <ServicesDeletionLogs />

   

    

        </Container>
      </div>
    </>
  )
}

export default newPage
